const CONST = {
    DATE_FORMAT_LL: 'll',
    DATE_FORMAT: 'M/D/YYYY',
    DATE_FORMAT_WITH_TIME: 'DD.MM.YYYY HH:mm',
    DATE_TIME: 'HH:mm',
    DATE_STANDARD_FORMAT: 'DD/MM/YYYY'
};

export default CONST;